import { Sprite } from "pixi.js";
import { UpgradeResourcePackage } from "../resources/UpgradeResourcePackage";
import { UpgradeItemElementType } from "../../../common/models/Building/types/UpgradeItemElementType";

export class UpgradeResourceIcon extends Sprite {
    public readonly upgradeResourceType: UpgradeItemElementType;
    private readonly upgradeResources: UpgradeResourcePackage;

    public constructor(
        upgradeResources: UpgradeResourcePackage,
        upgradeResourceType: UpgradeItemElementType,
    ) {
        super(upgradeResources.assets_views_upgrade_upgrade_resources_gold_png);
        this.upgradeResources = upgradeResources;
        this.updateIconByResourceType(upgradeResourceType);
    }

    public updateIconByResourceType(upgradeResourceType: UpgradeItemElementType): void {
        switch (upgradeResourceType) {
            case UpgradeItemElementType.APPLE:
                this.texture = this.upgradeResources.assets_views_upgrade_upgrade_resources_gold_png;;
                break;
            case UpgradeItemElementType.STRAWBERRY:
                this.texture = this.upgradeResources.assets_views_upgrade_upgrade_resources_purple_diamonds_png;
                break;
            default:
                this.texture = this.upgradeResources.assets_views_upgrade_upgrade_resources_green_diamonds_png;
                break;
        }
    }
}